import {  Store } from '@mui/icons-material';
import { Box, Card, CardActionArea, CardContent,  Chip, Grid, Typography } from '@mui/material';
import React from 'react';




export const StoreCard = ({ type, storeName, storeid, address, cardActionHandler }) => {
    return (
        <Grid item key={storeName}>
            <Card xs={2} elevation={6} >
                <CardActionArea onClick={() => cardActionHandler(type, storeid)}
                sx={{paddingTop:1}}
                >
                    <center>{type === 0 ? <Chip size="small" label="Admin" style={{ borderColor: "#ff6d00", color: "#ff6d00" }} variant="outlined" />
                        : (type === 1) ? <Chip size="small" label="Manager" style={{ borderColor: "#ffab00", color: "#ffab00" }} variant="outlined" /> : <Chip size="small" label="User" style={{ borderColor: "#3f51b5", color: "#3f51b5" }} variant="outlined" />}</center>
                    <Box sx={{padding:0.5}}/>
                    {/* <CardMedia
                        component="img"
                        height="100"
                        width="170"
                        image=""
                        alt="green iguana"
                    /> */}
                    <center> <Store sx={{textAlign:'center',fontSize:'120px'}}></Store></center>
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                            {storeName}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {storeid} <br />
                            {address} <br />

                        </Typography>
                    </CardContent>
                </CardActionArea>
            </Card>
        </Grid>
    );
}